function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8093A4",
  fillRule: "evenodd",
  d: "M10.5 1.438a2.25 2.25 0 0 1 2.246 2.117l.004.133v.75h3a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.75.75H15v9.75a2.25 2.25 0 0 1-2.118 2.246l-.132.003h-7.5a2.25 2.25 0 0 1-2.246-2.117L3 15.687v-9.75h-.75a.75.75 0 0 1-.743-.648L1.5 5.188a.75.75 0 0 1 .75-.75h3v-.75A2.25 2.25 0 0 1 7.368 1.44l.132-.004h3zm3 4.5h-9v9.75c0 .384.29.701.663.744l.087.006h7.5a.75.75 0 0 0 .745-.663l.005-.088v-9.75zm-6 2.25a.75.75 0 0 1 .75.75v4.5a.75.75 0 1 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75zm3 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 1 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75zm0-5.25h-3a.75.75 0 0 0-.745.662l-.005.088v.75h4.5v-.75a.75.75 0 0 0-.663-.745l-.087-.006z"
});

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.391b7977.svg";
export { ForwardRef as ReactComponent };